'use strict';
define([
    'angular',
    'modules/googleads/planner/planner.controller'
], function (angular, PlannerController) {
    var app = angular.module('app.googleads.planner', []);
    app.controller('GoogleAdsPlannerCtrl', PlannerController);
    return app;
});
